import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable()
export class StoreStateService {

  private changeSource = new Subject<boolean>();

  storeChanged$ = this.changeSource.asObservable();

  constructor() {
  }

  isStoreChanged(storeChanged: boolean) {
    this.changeSource.next(storeChanged);
  }
}
